export enum CodingReviewMode {
  ENCOUNTER = "Encounter",
  DIAGNOSIS = "Diagnosis",
  DIAGNOSIS_V2_2 = "DiagnosisV2.2",
  DIAGNOSIS_V3 = "DiagnosisV3",
}
